import * as React from "react";
const SvgFeatureFlag = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4 2V12H2V14H4V22H6V14H12L18 20V4L12 10H6V2H4Z", fill: "currentColor" }));
export default SvgFeatureFlag;
